import { __decorate } from "tslib";
import Stakeholder from "@/classes/Stakeholder";
import Modal from "@/components/Modal.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import { Component, Vue } from "vue-property-decorator";
let StakeholderEditor = class StakeholderEditor extends Vue {
    addStakeHolder(tariffs) {
        const store = this.$store;
        const userEmail = this.$data.addStakeHolderData.email;
        const fn = function createStakeholder(stakeholderItem) {
            return store.dispatch("createStakeholderConnectionAsync", {
                email: userEmail,
                tariffId: stakeholderItem.id,
            });
        };
        const allCreateActions = tariffs.map(fn);
        const results = Promise.all(allCreateActions);
        results.then(() => {
            this.loadStakeholders();
            this.$data.addStakeholderModal = false;
        });
    }
    impersonateUser(userItem) {
        const impersonated = new Stakeholder(userItem);
        this.$store.dispatch("impersonateUser", impersonated);
    }
    removeStakeholderData(inputEmail, inputTariffId) {
        const obj = { email: inputEmail, tariffId: inputTariffId };
        const foundItem = this.$data.selectedStakeholder.tariffs.filter((item) => {
            return item.tariffId === inputTariffId;
        });
        this.$store.dispatch("removeStakeholderconnectionAsync", obj).then(() => {
            const itemIndex = this.$data.selectedStakeholder.tariffs.indexOf(foundItem[0]);
            if (itemIndex !== -1) {
                this.$data.selectedStakeholder.tariffs.splice(itemIndex, 1);
            }
            this.loadStakeholders();
            if (this.$data.selectedStakeholder.tariffs.length === 0) {
                this.$data.editStakeholderModal = false;
            }
        });
    }
    loadStakeholders() {
        this.$store.dispatch("getStakeholderListAsync").then((result) => {
            this.$data.stakeholders = null;
            this.$data.stakeholders = result.data;
            this.$data.stakeholders = this.$data.stakeholders.slice(0, this.$data.stakeholders.length);
        });
    }
    showEditModal(stakeholder) {
        this.$data.editStakeholderModal = true;
        this.$data.selectedStakeholder = stakeholder;
    }
};
StakeholderEditor = __decorate([
    Component({
        data() {
            return {
                theme: this.$store.getters.getTheme,
                selectedTarifftoAdd: [],
                tariffsDropdown: null,
                filter: "",
                tariffFilter: "",
                stakeholders: null,
                addStakeholderModal: false,
                addStakeHolderData: { email: "" },
                sortbyValue: "email",
                stakeholderHeaders: [
                    { text: "Email", value: "email" },
                    { text: "Impersonate", value: "impersonate", sortable: false },
                    { text: "Edit", value: "edit", sortable: false },
                ],
                editHeaders: [
                    { text: "ID", value: "tariffId" },
                    { text: "Name", value: "tariffName" },
                    { text: "Customer", value: "customerName" },
                    { text: "Delete", value: "delete", sortable: false },
                ],
                tariffSelectHeaders: [
                    { text: "Customer", value: "customerName" },
                    { text: "Tariff", value: "name" },
                ],
                impersonateText: "Impersonate",
                selectedStakeholder: null,
                editStakeholderModal: false,
            };
        },
        created() {
            const storeTariffs = this.$store.getters.getGlobalTariffs;
            this.$data.tariffsDropdown = storeTariffs.tariffs;
            // loading the stakeholder list
            this.loadStakeholders();
        },
        components: {
            WhiteBox,
            Modal,
        },
    })
], StakeholderEditor);
export default StakeholderEditor;
